/**
 * D375: "Open on start". The world that opens by itself after the landing, or none, which
 * asks each time. Kept per device in localStorage with the other settings (the flat map, the
 * level signs); storage that throws keeps it for this session only. The landing's minimum
 * wait can be shortened by a test with `LANDING_MIN_KEY`; players never set it.
 */
import { useEffect, useState } from 'preact/hooks';

export const DEFAULT_WORLD_KEY = 'hedgerow-default-world';
/** Test setups only: "0" skips the landing's minimum wait; "open" also skips the chooser. */
export const LANDING_MIN_KEY = 'hedgerow-landing-min';

function read(): string | null {
  try {
    return globalThis.localStorage?.getItem(DEFAULT_WORLD_KEY) || null;
  } catch {
    return null;
  }
}

let current = read();
const listeners = new Set<(id: string | null) => void>();

export function defaultWorld(): string | null {
  return current;
}

export function setDefaultWorld(id: string | null): void {
  current = id;
  try {
    if (id) globalThis.localStorage?.setItem(DEFAULT_WORLD_KEY, id);
    else globalThis.localStorage?.removeItem(DEFAULT_WORLD_KEY);
  } catch {
    // Kept for this session only.
  }
  for (const fn of listeners) fn(id);
}

export function useDefaultWorld(): [string | null, (id: string | null) => void] {
  const [value, setValue] = useState(current);
  useEffect(() => {
    listeners.add(setValue);
    return () => void listeners.delete(setValue);
  }, []);
  return [value, setDefaultWorld];
}

function landingFlag(): string | null {
  try {
    return globalThis.localStorage?.getItem(LANDING_MIN_KEY) ?? null;
  } catch {
    return null;
  }
}

export function landingMinSkipped(): boolean {
  const v = landingFlag();
  return v === '0' || v === 'open';
}

export function landingChooserSkipped(): boolean {
  return landingFlag() === 'open';
}
